module.exports = __webpack_public_path__ + "0f8045094af02fb2e9cb1d381411e608.png";